"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(_ref) {
  var current = _ref.current,
      next = _ref.next;

  if (!next) {
    return false;
  }

  var currentKeySeqArray = current.keySeq().toJS();
  var nextKeySeqArray = next.keySeq().toJS();

  if (currentKeySeqArray.length !== nextKeySeqArray.length) {
    return true;
  }

  for (var i = 0; i < currentKeySeqArray.length; i++) {
    if (currentKeySeqArray[i] !== nextKeySeqArray[i]) {
      return true;
    }
  }

  return false;
};

exports.default = _default;
module.exports = exports.default;